import { htmlToPlainText } from './htmlToPlainText';

export type TranslateLike = (key: string) => string;

export type AssignedTo = {
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  teamName: string | null | undefined;
};

export type Participant = { name?: string | null };

const activityTypeToTitle = (
  activityType: string,
  t: TranslateLike,
): string => {
  if (activityType === 'visit') {
    return t('visit');
  }
  if (activityType === 'call') {
    return t('call');
  }
  if (activityType === 'task') {
    return t('task');
  }
  return '';
};

export function getDefaultSubject({
  t,
  assignedTo,
  participants,
  activityType,
}: {
  t: TranslateLike;
  assignedTo: AssignedTo;
  participants?: ReadonlyArray<Participant> | null;
  activityType: string;
}): string {
  const teamName = assignedTo.teamName ? `(${assignedTo.teamName})` : '';

  const names = (participants ?? [])
    .map(u => u?.name?.trim() ?? '')
    .filter(name => name !== '');
  const joinedNames = names.join(', ');

  const hasAssignedToInfo =
    assignedTo.firstName || assignedTo.lastName || assignedTo.teamName;
  const separator = joinedNames && hasAssignedToInfo ? ' - ' : '';

  return `${activityTypeToTitle(
    activityType,
    t,
  )}${separator}${joinedNames} <> ${assignedTo.firstName ?? ''} ${
    assignedTo.lastName ?? ''
  } ${teamName}`.trim();
}

// Quill's semantic HTML always opens with a block tag. Anything else is
// markdown or plain text (note dialog, n8n imports), where `<…>` is content.
const QUILL_HTML = /^\s*<(p|h[1-6]|ol|ul|blockquote|pre|div)[\s>]/i;

/** One-line preview of `activities.note` for table cells; '' when empty. */
export const activityNotePlainText = (
  note: string | null | undefined,
): string => {
  if (note == null) {
    return '';
  }
  return (QUILL_HTML.test(note) ? htmlToPlainText(note) : note)
    .replace(/\s+/g, ' ')
    .trim();
};
